import request from '@/utils/request'


export function queryService(data) {
  return request({
    url: '/admin/service/queryService',
    method: 'post',
    data: data
  })
}


//课后服务
export function workerService(data) {
  return request({
    url: '/admin/service/workerService',
    method: 'post',
    data: data
  })
}

//指定教师
export function setServiceTeacher(data) {
  return request({
    url: '/admin/service/setServiceTeacher',
    method: 'post',
    data: data
  })
}

//指定洗澡人员
export function setBathWorker(data) {
  return request({
    url: '/admin/service/setBathWorker',
    method: 'post',
    data: data
  })
}

// 查询课程列表
export function courseList(params) {
  return request({
    url: '/admin/lessons/list',
    method: 'get',
    params: params
  })
}

// 查询课后评价列表
export function finishList(params) {
  return request({
    url: '/admin/lessons/finish/list',
    method: 'get',
    params: params
  })
}
// 删除多媒体评价
export function deleteMediaById(data) {
  return request({
    url: '/admin/lessons/finish/media',
    method: 'DELETE',
    data: data
  })
}

// 查询课程配置
export function getConfigData(params) {
  return request({
    url: '/admin/lessons/config',
    method: 'get',
    params: params
  })
}
// 设置课程配置
export function setCourseConfig(data) {
  return request({
    url: `/admin/lessons/config/${data.id}`,
    method: 'PUT',
    data: data
  })
}
// 查询教师课后评价
export function getCourseEvalData(params) {
  return request({
    url: '/admin/lessons/finish/teacher/evaluation',
    method: 'get',
    params: params
  })
}
// 教师课后评价
export function updateCourseEval(data) {
  return request({
    url: '/admin/lessons/finish/teacher/evaluation',
    method: 'PUT',
    data: data
  })
}
// 查询课程完成后的评价内容[多媒体]
export function getCourseMediaData(params) {
  return request({
    url: '/admin/lessons/finish/teacher/evaluation/media',
    method: 'get',
    params: params
  })
}
// 插入/更新课程完成后的评价内容[多媒体]
export function updateCourseMedia(data) {
  return request({
    url: '/admin/lessons/finish/teacher/evaluation/media',
    method: 'POST',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/AfterClassService.js